module.exports = __webpack_public_path__ + "img/sync-failed.899be9fc.png";